export const BASE_URL = 'https://adike-api-472566164634.us-central1.run.app/api';
export const LEXCORE_URL = 'https://api-tienda-730868720520.us-central1.run.app/api';
export const EMAIL = 'contacto@consultor-ia.tech';